export function validatePhone(phone) {
  return /^[\d]{10}$/.test(phone);
}